import { Model } from './model';

export class Domain extends Model {
  logoUrl: string;
  logoMobileUrl: string;
  faviconUrl: string;
  seoHtml: string;
  canRegister: boolean;
  canResetPassword: boolean;
  canViewSettings: boolean;
  style: any;
  shopUrl: string;
  tpoaSenderManagement: string;
  useUniversalLogin: boolean;
  brand: Brand;
  customDomain?: string;
  clientId?: string;

  afterDeserialize(input: any) {
    if (!this.logoMobileUrl) {
      this.logoMobileUrl = this.logoUrl;
    }
    if (!this.tpoaSenderManagement) {
      this.tpoaSenderManagement = 'NONE';
    }
  }
}

export class Brand extends Model {
  systemId: string;
  name: string;
  idNation: string;
}
